module.exports = __webpack_public_path__ + "img/album14_02.2b8c7d90.jpg";